import React from 'react';
import { Small } from '@finect/tabular-core/Small';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { LogoBlock } from './partials';
import { MorningstarLogo } from './MorningstarLogo';
export var InformationSource = function InformationSource(_ref) {
  var _ref$withFinect = _ref.withFinect,
    withFinect = _ref$withFinect === void 0 ? false : _ref$withFinect;
  return React.createElement("div", null, React.createElement(LogoBlock, null, React.createElement(MorningstarLogo, null)), React.createElement(Small, {
    light: true
  }, 'Datos de mercado proporcionados por Morningstar. ', withFinect ? React.createElement("div", null, "Elaborado por", ' ', React.createElement(AppLink, {
    href: getSuperPartnerBaseURL(),
    title: "Finect - Invertir mejor"
  }, "Finect"), ".", ' ') : null));
};